import { TelemetryData } from "./TelemetryData";
// This is essential to causing the ETW events to be treated as Microsoft Telemetry.
export const microsoftTelemetryGroupId = "{4F50731A-89CF-4782-B3E0-DCE8C90476BA}";
// Register your provider in externalApi::initializeTelemetryProviders and store their related information here
// Dashboard telemetry provider information
export const dashboardProviderId = "{87ba0ea5-fe69-5002-9a52-849c32319a2b}";
export const dashboard = "Microsoft.Windows.Dashboard";
export async function addPartCData(partC) {
    // only try to get FPO feature once
    return JSON.stringify(Object.assign({ "isWindowShown": TelemetryData.isWindowVisible, "pcsBuildVersion": TelemetryData.pcsBuildVersion, "serverDriven": true, "view": TelemetryData.view, "widgetsBuildVersion": TelemetryData.widgetsBuildVersion }, partC), replacer);
}
// Replacer function for customizing stringification on a given type
function replacer(key, value) {
    var _a;
    // WidgetAPI is a circular Map which causes it to crash when converted to an Array, filter it out by checking for the visibility API
    if (value instanceof Map && !value.has("visibility")) {
        // Maps do not support JSON.stringification by default, so we convert their entries to an Array
        return {
            dataType: "Map",
            value: Array.from(value.entries()),
        };
    }
    else if (value instanceof Error || value instanceof DOMException) {
        // Error properties are not enumerated(and thus not stringified by default), so we must get them manually
        const stringifiedValue = { name: value.name };
        Object.getOwnPropertyNames(value).forEach(function (keyName) {
            stringifiedValue[keyName] = value[keyName];
        });
        return stringifiedValue;
    }
    else if (value instanceof IDBOpenDBRequest) {
        return { name: (_a = value.error) === null || _a === void 0 ? void 0 : _a.name };
    }
    else {
        return value;
    }
}
